<script setup lang="ts">
import { ref, Ref } from 'vue';
import DefaultLayout from './layouts/DefaultLayout.vue';
import { odsPopupContainer } from 'omind-design-system/components/odsPopup';
import { useDataStore } from '@/domains/-data/stores/useDataStore.ts';

const version = import.meta.env.VITE_COLLECTIVE_TOOLS_VERSION;
const dataStore = useDataStore();

const showVersion: Ref<boolean> = ref(false);

window.onkeydown = (event: KeyboardEvent) => {
  /* if(event.ctrlKey)
        console.log(event.ctrlKey ? 'CTRL ON' : 'CTRL OFF', event.altKey ? 'ALT ON' : 'ALT OFF', event.shiftKey ? 'SHIFT ON' : 'SHIFT OFF', event.key, event.code) */

  if (event.ctrlKey && event.altKey && event.code === 'KeyV') {
    showVersion.value = !showVersion.value;
    dataStore.showDebugVersion = showVersion.value;
  }
  /* if (event.ctrlKey && event.altKey && event.key === "d" && isInDevelopmentMode())
      showDebug.value = !showDebug.value;
    if (event.ctrlKey && event.altKey && event.key === "l" && isInDevelopmentMode())
      showLocaleKeys.value = !showLocaleKeys.value; */
};
</script>

<template>
  <DefaultLayout />
  <odsPopupContainer />
  <div class="ods-tooltip-container"></div>
  <div v-show="showVersion" id="version-label-container" class="version-label-container"></div>
  <span v-show="showVersion" class="app-version" v-text="`v${version}`" />
</template>

<style lang="scss">
.ods-tooltip-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 1000;
}

.app-version {
  position: fixed;
  bottom: 0;
  right: 0;
  font-size: 0.75rem;
  padding: 0.5em;
  background-color: white;
}

.version-label-container {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;

  .version-label {
    position: absolute;
    background: #ff0000;
    color: var(--color-neutral-10);
    padding: 0.5rem;
    top: 0;
    right: 0;
    left: auto;
    transform: translate(5px, 10px);
    border-radius: var(--border-radius-standard);
    font-weight: 600;
  }

  .version-border {
    position: absolute;
    border: dashed 2px #ff0000;
    transform: scale(0.9985);
  }
}
</style>
